import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/components/AuthContext'
import { Layout } from '@/components/Layout'
import { StatsOverview } from './StatsOverview'
import { SteamStats } from './SteamStats'
import { FortniteStats } from './FortniteStats'
import { XboxStats } from './XboxStats'
import { GameLibrary } from './GameLibrary'

export function StatsApp() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<StatsOverview />} />
          <Route path="/library" element={<GameLibrary />} />
          <Route path="/steam" element={<SteamStats />} />
          <Route path="/fortnite" element={<FortniteStats />} />
          <Route path="/xbox" element={<XboxStats />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}
